export default {"src":"/_next/static/media/profile_s.62f8fb75.svg","height":54,"width":54,"blurWidth":0,"blurHeight":0};